var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"landing-page"}},[_c('div',{staticClass:"grid-area-number-1"},[_c('TabBar')],1)]),_c('div',[_c('HaveAQuestion'),_c('LandingPageFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }